import { createContext, useContext, useState } from "react"

const AppContext = createContext({});
const useAppContext = () => {return useContext(AppContext);}

const AppContextWrapper = ({children}) => {
    const [AppData, setAppData] = useState({});

    const updateAppData = (key, value = null) => {
        if(key){
            setAppData(prev => {
                return {
                    ...prev,
                    [key]: value
                }
            })
        }
    }

    const resetAppData = () => {
        setAppData({});
    }

    const appvalues = {AppData,updateAppData, resetAppData}

    return (
        <AppContext.Provider value={appvalues}>
            {children}
        </AppContext.Provider>
    )
}

export {AppContextWrapper as default, useAppContext}